import { Component, Input, output, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { QuillModule } from 'ngx-quill';
import { MatTooltipModule } from '@angular/material/tooltip';

export const quillEditorOptions = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    ['blockquote', 'code-block'],

    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    [{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
    [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
    [{ 'direction': 'rtl' }],                         // text direction

    [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    [{ 'font': [] }],
    [{ 'align': [] }],

    ['clean'],                                         // remove formatting button

    ['link', 'image', 'video']                         // link and image, video    ],
  ]};


@Component({
  selector: 'app-quill-html',
  standalone: true,
  imports: [FormsModule,QuillModule,MatTooltipModule],
  templateUrl: './quill-html.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './quill-html.component.scss'
})
export class QuillHtmlComponent {
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() html: string = '';
  quillEditorOptions = quillEditorOptions;
  readonly htmlChange = output<string>();
  readonly textChange = output<string>();
  text: string = '';
  quillEditorReady(event: any) {
    /* {
  editor: editorInstance, // Quill
  html: html, // html string
  text: text, // plain text string
  content: content, // Content - operatins representation
  delta: delta, // Delta
  oldDelta: oldDelta, // Delta
  source: source // ('user', 'api', 'silent' , undefined)
  }*/
    this.html = event.html ?? '';
    this.text = event.text ?? '';
    if (this.htmlChange)
      this.htmlChange.emit(this.html)
    else
      alert('事件 htmlChange 未設定');
    if (this.textChange) this.textChange.emit(this.text)
    else
      alert('事件 textChange 未設定');

  }

}
